import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import formatTrimToUpper from '../../formatTrimToUpper';
import * as max from '../../max-length-validators';
import nlPostcode from '../../validationByCountry/Netherlands/nl-postcode';
import * as required from '../../required-validators';

const FieldDefinitionNL = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    transform: formatTrimToUpper,
    maxLength: 7,
    validate: [required.postCode, max.lengthPostCode(7), nlPostcode],
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  townCity,
  county,
];

export default FieldDefinitionNL;
